export enum CAST_MEDIA_DETAIL_TEST_IDS {
    ACTION_BUTTON = 'action_button',
}
